module.exports = __webpack_public_path__ + "img/power_settings_new.c9116a36.svg";